<mat-form-field appearance="fill" class="filters-form-field">
    <mat-label>{{label()}}</mat-label>
    <mat-icon matPrefix class="me-1">{{icon()}}</mat-icon>
    <mat-select [formControl]="multiple() ? selectedOptions : selectedOption" [multiple]="multiple()">
        @if (searchBar()) {
        <mat-form-field id="select-list__search-input" class="example-full-width">
            <input matInput type="search" placeholder="Search..." [formControl]="searchStringInput">
        </mat-form-field>
        }
        <mat-option class="signal"></mat-option>
        @if (!multiple() && (searchBar() || initialSelectedOption()) && selectedOption.getRawValue() &&
        selectedOptions.getRawValue()) {
        <mat-option value={{selectedOption.value}}>{{getViewByValue(selectedOption.value)}}</mat-option>
        }
        @for (option of currentOptionList(); track index; let index = $index) {
        @if (matchesSearch(option.view) && option.value !== selectedOption.value) {
        <mat-option value={{option.value}} [disabled]="option.disabled">{{option.view}}</mat-option>
        }
        }
    </mat-select>
    @if (selectedOption.getRawValue()) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="selectedOption.setValue(null)">
        <mat-icon>close</mat-icon>
    </button>
    }
</mat-form-field>
